<template>
  <view class="submit-rm-container">
    <view class="navbarBg">
      <es-navbar title="人证核验" wx:style="{{navbarStyle}}" ></es-navbar>
    </view>
    <view class="es-content">
      <view class="es-submit-verification">
        <block wx:if="{{faceVerificaStatus}}">
          <view class="es-loading-box">
            <image
              src="https://pt-starimg.didistatic.com/static/starimg/img/V4XDon0zUm1644304468042.png"
              mode="scaleToFill"
              class="es-sumit-loading"
            ></image>
            <text class="es-loading-text">人证信息正在审核中</text>
            <text class="es-loading-texts">请耐心等候</text>
            <view class="es-icon-box-loading">
              <image
                src="https://pt-starimg.didistatic.com/static/starimg/img/K9mLrtOGSQ1642067505569.png"
                mode="scaleToFill"
                class="es-icon-loading"
              ></image>
            </view>
          </view>
        </block>
        <block wx:else>
          <view class="es-loading-box">
            <image
              src="https://pt-starimg.didistatic.com/static/starimg/img/7iQiGAwq3T1644304412865.png"
              mode="scaleToFill"
              class="es-sumit-loading_fail"
            ></image>
            <text class="es-loading-text">人证核验失败，请重试</text>
            <view class="buttonStyle" bindtap="onClickAgain">重新核验</view>
            <view wx:if="{{!isCxvipVerify}}" class="buttonStyleNone" bindtap="onClickMessage">短信核验</view>
          </view>
        </block>
      </view>
    </view>
  </view>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from "@/common/jump";
  createPage({
    data: {
      reviewStatus: true,
      imageDataBase64: [],
      state: true, // 默认人脸审核页面状态
      navbarStyle: {
 				background: 'red',
 			},
    },
    computed: {
      ...store.mapState({
        faceVerificaStatus: 'login12306.faceVerificaStatus',
        isSmsCode: 'login12306.isSmsCode',
        userInfo12306: 'login12306.userInfo12306'
      }),
      isCxvipVerify() {
        return this.isSmsCode === 4
      }
    },
    methods: {
      ...store.mapMutations({
        faceVerificationClose: 'login12306.faceVerification'
      }),
      onClickAgain() {
        this.state = true
        this.faceVerificationClose({
          code: '0'
        })
        //  innerRouter.replace(pagePath().WITNESSVERIFICATION)
        innerRouter.redirect(pagePath().WITNESSVERIFICATION)
        // innerRouter.goback()
      },
      onClickMessage() {
        //  innerRouter.push(pagePath().VERIFICATIONCODE)
        innerRouter.redirect(pagePath().VERIFICATIONCODE)
      }
      // handleAgain(value) {
      //   this.state = value.detail.statusType
      //   this.faceVerificationClose({
      //     code: '0'
      //   })
      //   innerRouter.push(pagePath().WITNESSVERIFICATION)
      // }
    },
    created() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'
  .submit-rm-container
    display flex
    flex-direction column
  .navbarBg
    background-color $train-color-fff
  .es-witn-verification
    background #ffffff
  .es-content
    flex 1
    background #ffffff
  .es-submit-verification
    display flex
    justify-content center
  .es-sumit-loading
    width 125px
    height 85px
    margin 0 auto
    display block
  .es-sumit-loading_fail
    width 100px
    height 66px
    margin 0 auto
    display block
  .es-loading-box
    padding-top 40px
    position relative
    z-index 999
    background #ffffff
  .es-loading-text
    display block
    text-align center
    font-weight bold
    margin-top 10px
    padding-bottom 5px
  .es-loading-texts
    display block
    text-align center
    font-size 14px
    color $train-color-999
    padding-top 10px
  .es-icon-box-loading
    position relative
  .es-icon-loading
    width 24px
    height 24px
    position absolute
    top 10px
    left 50%
    margin-left -15px
    animation turn 1s linear infinite
  @keyframes turn
    0%
      -webkit-transform rotate(0deg)
    25%
      -webkit-transform rotate(90deg)
    50%
      -webkit-transform rotate(180deg)
    75%
      -webkit-transform rotate(270deg)
    100%
      -webkit-transform rotate(360deg)
  .buttonStyle
    margin-top 24px
    color white
    background #1473FF
    font-size 16px
    border-color #1473FF
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
    width 190px
    // box-shadow 0 1px 2px rgb(0 0 0 / 20%)
  .buttonStyleNone
    margin-top 24px
    color #1473FF
    background #ffffff
    font-size 16px
    border 1px #1473FF solid
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
</style>

<script name='json'>
  module.exports = {
    component: true,
    // navigationBarTitleText: '人证核验',
    usingComponents: {
    }
  }
</script>